import React, { useEffect, useRef, useState } from 'react';
import * as Font from 'expo-font';
import * as FileSystem from 'expo-file-system';
import Acceso from './src/screens/Acceso.js';
import CamaraS from './src/screens/CamaraS.js';
import ListadoTiendas from './src/screens/ListadoTiendas';
import ListadoUPCS from './src/screens/ListadoUPCS';
import UPC from './src/screens/UPC';
import Incidencias from './src/screens/Incidencias';
import Tienda from './src/screens/Tienda';
import Fotos from './src/screens/Fotos';
import DashboardRuta from './src/screens/DashboardRuta';
import Dashboard from './src/screens/Dashboard';
import FotoProducto from './src/screens/FotoProducto';
import MenuUpc from './src/screens/MenuUpc';
import TareasPendientes from './src/screens/TareasPendientes';
import TareasPendientesUPC from './src/screens/TareasPendientesUPC';
import RegistroCoordenadas from './src/screens/RegistroCoordenadas';
import DashboardTienda from './src/screens/DashboardTienda';
import UPCLote from './src/screens/UPCLote';
import Lotes from './src/screens/Lotes';
import ScannerUpc from './src/screens/ScannerUpc';
import { createStackNavigator } from '@react-navigation/stack';
import { NavigationContainer } from '@react-navigation/native';
import FotosCarrete from './src/screens/FotosCarrete';
import MenuFacturas from './src/screens/MenuFacturas';
import FacturasListado from './src/screens/FacturasListado';
import Factura from './src/screens/Factura';
import { Provider as PaperProvider } from 'react-native-paper';
import theme from './lib/theme.js';
import 'react-native-reanimated';
import 'react-native-gesture-handler';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import '@expo/metro-runtime';
import { setVariables } from './src/modules/component/variables';
import { GeolocationProvider } from "./src/providers/GeoLocationProvider";

import { StyleSheet, Text, View, Image, TextInput, TouchableOpacity, Alert, LogBox } from 'react-native';
//import * as Segment from expo-analytics-segment;

//Segment.setEnabledAsync(true);
const Stack = createStackNavigator();
setVariables();

const linking = {
  // `prefixes` son los dominios/esquemas URL que tu aplicación manejará.
  // Aquí, incluimos tu dominio de producción.
  // Es una buena práctica incluir 'exp://' o tu schema de Expo Go para desarrollo local.
  prefixes: [
    'https://promotoria.eurekamx.com',
    'https://eureka.iscisolutions.com',
    'http://localhost:19006',
    'exp://',
  ],
  config: {
    screens: {
      Acceso: 'acceso', // promotoria.eurekamx.com/acceso
      RegistroCoordenadas: 'registro-coordenadas', // promotoria.eurekamx.com/registro-coordenadas
      ListadoTiendas: 'listado-tiendas',
      ListadoUPCS: 'listado-upcs',
      MenuUpc: 'menu-upc',
      UPC: 'upc', // Ejemplo de parámetro opcional si tu UPC puede tomar un ID
      Incidencias: 'incidencias',
      Tienda: 'tienda', // Otro ejemplo de parámetro si tu Tienda puede tomar un ID
      Fotos: 'fotos',
      FotoProducto: 'foto-producto',
      Dashboard: 'dashboard',
      DashboardRuta: 'dashboard-ruta',
      TareasPendientes: 'tareas-pendientes',
      DashboardTienda: 'dashboard-tienda',
      UPCLote: 'upc-lote',
      Lotes: 'lotes',
      ScannerUpc: 'scanner-upc',
      FotosCarrete: 'fotos-carrete',
      MenuFacturas: 'menu-facturas',
      FacturasListado: 'facturas-listado',
      Factura: 'factura', // Si tu factura puede tener un ID
      TareasPendientesUPC: 'tareas-pendientes-upc',
    },
  },
};

LogBox.ignoreLogs(['Invalid prop `textStyle` of type `array` supplied to `Cell`']);
function LogoTitle(props) {
  switch (props.children) {
    case 'Tienda':
      return (
        <View style={{ width: "300px", flex: 1, alignContent: 'center', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row' }}>
          <View style={{ width: '245px' }}>
            <Text style={theme.banner}>Tienda</Text>
          </View>
          <View style={{ width: '60px', textAlignLast: 'right', paddingRight: "5px" }}>
            <Text style={{ color: "#ccc" }}>{versionApp}</Text>
          </View>
          <View style={{ width: '60px' }}>
            <Image
              source={require('./assets/logo.png')}
              contentFit="cover"
              transition={1000}
              style={{ width: 45, height: 50 }}
            />
          </View>
        </View>
      );
      break;
    case 'ListadoUPCS':
      return (
        <View style={{ minWidth: "300px", flex: 1, alignContent: 'center', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row' }}>
          <View style={{ width: '245px' }}>
            <Text style={theme.banner}>Listado de productos</Text>
          </View>
          <View style={{ width: '60px', textAlignLast: 'right', paddingRight: "5px" }}>
            <Text style={{ color: "#ccc" }}>{versionApp}</Text>
          </View>
          <View style={{ width: '60px' }}>
            <Image
              source={require('./assets/logo.png')}
              contentFit="cover"
              transition={1000}
              style={{ width: 45, height: 50 }}
            />
          </View>
        </View>
      );
      break;
    case 'UPC':
      return (
        <View style={{ minWidth: "300px", flex: 1, alignContent: 'center', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row' }}>
          <View style={{ width: '245px' }}>
            <Text style={theme.banner}>Inventario</Text>
          </View>
          <View style={{ width: '60px', textAlignLast: 'right', paddingRight: "5px" }}>
            <Text style={{ color: "#ccc" }}>{versionApp}</Text>
          </View>
          <View style={{ width: '60px' }}>
            <Image
              source={require('./assets/logo.png')}
              contentFit="cover"
              transition={1000}
              style={{ width: 45, height: 50 }}
            />
          </View>
        </View>
      );
      break;
    case 'UPCLote':
      return (
        <View style={{ minWidth: "300px", flex: 1, alignContent: 'center', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row' }}>
          <View style={{ width: '245px' }}>
            <Text style={theme.banner}>Inventario por lotes</Text>
          </View>
          <View style={{ width: '60px', textAlignLast: 'right', paddingRight: "5px" }}>
            <Text style={{ color: "#ccc" }}>{versionApp}</Text>
          </View>
          <View style={{ width: '60px' }}>
            <Image
              source={require('./assets/logo.png')}
              contentFit="cover"
              transition={1000}
              style={{ width: 45, height: 50 }}
            />
          </View>
        </View>
      );
      break;
    case 'FotoProducto':
      return (
        <View style={{ minWidth: "300px", flex: 1, alignContent: 'center', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row' }}>
          <Text style={{ ...theme.banner, color: "#fff" }}>Foto del producto</Text>
          <Text style={{ color: "#ccc" }}>{versionApp}</Text>
        </View>
      );
      break;
    case 'Fotos':
      return (
        <View style={{ minWidth: "300px", flex: 1, alignContent: 'center', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row' }}>
          <Text style={{ ...theme.banner, color: "#fff" }}>Fotos de {gTipoFoto}</Text>
          <Text style={{ color: "#ccc" }}>{versionApp}</Text>
        </View>
      );
      break;
    case 'DashboardTienda':
      return (
        <View style={{ minWidth: "300px", flex: 1, alignContent: 'center', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row' }}>
          <View style={{ width: '245px' }}>
            <Text style={theme.banner}>Estadísticas</Text>
          </View>
          <View style={{ width: '60px', textAlignLast: 'right', paddingRight: "5px" }}>
            <Text style={{ color: "#ccc" }}>{versionApp}</Text>
          </View>
          <View style={{ width: '60px' }}>
            <Image
              source={require('./assets/logo.png')}
              contentFit="cover"
              transition={1000}
              style={{ width: 45, height: 50 }}
            />
          </View>
        </View>
      );
      break;
    case 'ListadoTiendas':
      return (
        <View style={{ minWidth: "300px", flex: 1, alignContent: 'center', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row' }}>
          <View style={{ width: '245px' }}>
            <Text style={theme.banner}>Listado de tiendas</Text>
          </View>
          <View style={{ width: '60px', textAlignLast: 'right', paddingRight: "5px" }}>
            <Text style={{ color: "#ccc" }}>{versionApp}</Text>
          </View>
          <View style={{ width: '60px' }}>
            <Image
              source={require('./assets/logo.png')}
              contentFit="cover"
              transition={1000}
              style={{ width: 45, height: 50 }}
            />
          </View>
        </View>
      )
      break;
    case 'TareasPendientes':
      return (
        <View style={{ minWidth: "300px", flex: 1, alignContent: 'center', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row' }}>
          <View style={{ width: '245px' }}>
            <Text style={theme.banner}>Incidencias de la tienda</Text>
          </View>
          <View style={{ width: '60px', textAlignLast: 'right', paddingRight: "5px" }}>
            <Text style={{ color: "#ccc" }}>{versionApp}</Text>
          </View>
          <View style={{ width: '60px' }}>
            <Image
              source={require('./assets/logo.png')}
              contentFit="cover"
              transition={1000}
              style={{ width: 45, height: 50 }}
            />
          </View>
        </View>
      )
      break;
    case 'TareasPendientesUPC':
      return (
        <View style={{ minWidth: "300px", flex: 1, alignContent: 'center', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row' }}>
          <View style={{ width: '245px' }}>
            <Text style={theme.banner}>Incidencias del UPC</Text>
          </View>
          <View style={{ width: '60px', textAlignLast: 'right', paddingRight: "5px" }}>
            <Text style={{ color: "#ccc" }}>{versionApp}</Text>
          </View>
          <View style={{ width: '60px' }}>
            <Image
              source={require('./assets/logo.png')}
              contentFit="cover"
              transition={1000}
              style={{ width: 45, height: 50 }}
            />
          </View>
        </View>
      )
      break;
    default:
      break;
  }
  return (
    <View style={{ width: "300px", flex: 1, alignContent: 'center', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row' }}>
      <View style={{ width: '245px' }}>
        <Text style={theme.banner}>Eureka</Text>
      </View>
      <View style={{ width: '60px', textAlignLast: 'right', paddingRight: "5px" }}>
        <Text style={{ color: "#ccc" }}>{versionApp}</Text>
      </View>
      <View style={{ width: '60px' }}>
        <Image
          source={require('./assets/logo.png')}
          contentFit="cover"
          transition={1000}
          style={{ width: 45, height: 50 }}
        />
      </View>
    </View>
  );
}

function getActiveRouteName(state) {
  if (!state) return null;
  const route = state.routes[state.index];
  if (route.state) {
    return getActiveRouteName(route.state);
  }
  return route.name;
}


export default function App() {
  const [fontsLoaded, setFontsLoaded] = useState(true);

  useEffect(() => {
    // Attempt to load bundled font for native platforms.
    // Place the font file at `app/assets/fonts/ZTNature-Regular.ttf`.
    async function load() {
      try {
        await Font.loadAsync({
          ZTNature: require('../assets/fonts/ZTNature-Regular.ttf'),
        });
        setFontsLoaded(true);
        try {
          const { Text } = require('react-native');
          Text.defaultProps = Text.defaultProps || {};
          Text.defaultProps.style = { ...(Text.defaultProps.style || {}), fontFamily: 'ZTNature' };
        } catch (e) {
          console.log('Could not set Text.defaultProps', e);
        }
      } catch (e) {
        console.log('Font load failed', e);
      }
    }
    load();

  }, []);

  useEffect(() => {
    console.log("global.gEmpresa", global.gEmpresa);
    if (global.location.pathname != "/acceso" && global.gEmpresa === "") {
      window.location.href = "./acceso";
    }
  }, [])

  const inactivityTimeoutRef = useRef(null);

  useEffect(() => {
    const INACTIVITY_MS = global.sessionInactiva * 60 * 1000;

    const resetInactivity = () => {
      const currentScreen = global.currentRouteName || '';
      if (currentScreen === 'Acceso') {
        if (inactivityTimeoutRef.current) {
          clearTimeout(inactivityTimeoutRef.current);
          inactivityTimeoutRef.current = null;
        }
        return;
      }

      if (inactivityTimeoutRef.current) clearTimeout(inactivityTimeoutRef.current);
      inactivityTimeoutRef.current = setTimeout(() => {
        try {
          window.alert('Por seguridad, se cerró la sesión por inactividad.');
        } catch (e) {
          console.log('Alert failed', e);
        }
        try {
          window.location.href = './acceso';
        } catch (e) {
          console.log('Redirect failed', e);
        }
      }, INACTIVITY_MS);
    };

    const events = ['mousemove', 'mousedown', 'keypress', 'touchstart'];
    const onActivity = () => resetInactivity();

    events.forEach((ev) => window.addEventListener(ev, onActivity));
    window.addEventListener('routeChange', resetInactivity);
    resetInactivity();

    return () => {
      events.forEach((ev) => window.removeEventListener(ev, onActivity));
      window.removeEventListener('routeChange', resetInactivity);
      if (inactivityTimeoutRef.current) clearTimeout(inactivityTimeoutRef.current);
    };
  }, []);

  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      
        <PaperProvider theme={theme}>
          <GeolocationProvider>
          <NavigationContainer
            linking={linking}
            onStateChange={(state) => {
              try {
                const routeName = getActiveRouteName(state);
                global.currentRouteName = routeName;
                try {
                  window.dispatchEvent(new Event('routeChange'));
                } catch (e) {
                  console.log('Could not dispatch routeChange', e);
                }
              } catch (e) {
                console.log('Error getting route name', e);
              }
            }}
          >
            <Stack.Navigator>
              <Stack.Screen name="Acceso" component={Acceso} options={{ headerTitle: (props) => <LogoTitle {...props} />, headerShown: false }} />
              <Stack.Screen name="RegistroCoordenadas" component={RegistroCoordenadas} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="ListadoTiendas" component={ListadoTiendas} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="ListadoUPCS" component={ListadoUPCS} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="MenuUpc" component={MenuUpc} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="UPC" component={UPC} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="Incidencias" component={Incidencias} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="Tienda" component={Tienda} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="Fotos" component={Fotos} options={{
                unmountOnBlur: true,
                cardStyle: {
                  backgroundColor: '#000',
                },
                animationEnabled: false,
                headerStyle: {
                  backgroundColor: '#000',
                },
                headerTintColor: '#fff',
                headerTitle: (props) => <LogoTitle {...props} />
              }} />
              <Stack.Screen name="FotoProducto" component={FotoProducto} options={{
                unmountOnBlur: true,
                cardStyle: {
                  backgroundColor: '#000',
                },
                animationEnabled: false,
                headerStyle: {
                  backgroundColor: '#000',
                },
                headerTintColor: '#fff',
                headerTitle: (props) => <LogoTitle {...props} />
              }} />
              <Stack.Screen name="Dashboard" component={Dashboard} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="DashboardRuta" component={DashboardRuta} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="TareasPendientes" component={TareasPendientes} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="DashboardTienda" component={DashboardTienda} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="UPCLote" component={UPCLote} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="Lotes" component={Lotes} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="ScannerUpc" component={ScannerUpc} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="FotosCarrete" component={FotosCarrete} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="MenuFacturas" component={MenuFacturas} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="FacturasListado" component={FacturasListado} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="Factura" component={Factura} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
              <Stack.Screen name="TareasPendientesUPC" component={TareasPendientesUPC} options={{ headerTitle: (props) => <LogoTitle {...props} /> }} />
            </Stack.Navigator>
          </NavigationContainer>
          </GeolocationProvider>
        </PaperProvider>
      
    </GestureHandlerRootView>
  );
}


